const propertyOf = <TObj>(name: keyof TObj) => name;

export default propertyOf;
